<template>
<div class="chapter">
<div class="inner_page">
<div class="box">
<p class="boxtext"><a id="page_iv"></a></p><a id="page_iv">
</a></div><a id="page_iv">
<p class="copyright1">An <em>Original</em> Publication of POCKET BOOKS</p>
</a><p class="copyright"><a id="page_iv"><img alt="Images" src="images/pub1.jpg"/> POCKET BOOKS, a division of Simon &amp; Schuster Inc. 1230 Avenue of the Americas, New York, NY 10020<br/></a><a class="nounder" href="http://www.SimonandSchuster.com" target="_blank">www.SimonandSchuster.com</a></p>
<p class="copyright">Copyright © 1981 by Janet Dailey</p>
<p class="copyright">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. For information address Pocket Books, 1230 Avenue of the Americas, New York, NY 10020</p>
<p class="copyright">ISBN 978-1-4391-8914-6</p>
<p class="copyright">eISBN 978-1-4516-4030-4</p>
<p class="copyright">First Pocket Books printing January 1981</p>
<p class="copyright">26   25   24   23   22   21   20</p>
<p class="copyright">POCKET and colophon are registered trademarks of Simon &amp; Schuster Inc.</p>
<p class="copyright">Printed in the U. S. A.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?8bff2786